import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { AuthProvider } from "./contexts/AuthContext";
import { AbonnementProvider } from "./contexts/AbonnementContext";
import { AlertProvider } from "./contexts/AlertContext";

import ProtectedRoute from "./routes/ProtectedRoute";
import DashboardLayout from "./layouts/DashboardLayout";

// pages publiques
import HomePage from "./pages/auth/HomePage";
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";

// pages privées
import UsersList from "./pages/utilisateur/UsersList";
import UsersDesactive from "./pages/utilisateur/UsersDesactive";
import CreateUser from "./pages/utilisateur/CreateUser";
import UsageListPage from "./pages/usage/UsageListePage";
import Historique from "./pages/usage/Historique";
import Surveillance from "./pages/usage/Surveillance";
import EntrepriseListe from "./pages/entreprise/entrepriseList";
import CreateOrUpdateEntreprise from "./pages/entreprise/createOrUpdate";
import OffreListe from "./pages/offre/offreList";
import CreateOrUpdateOffre from "./pages/offre/createOrUpdate";
import Profile from "./pages/utilisateur/Profile";
import Setting from "./pages/utilisateur/Setting";
import HistoriqueClavier from "./pages/historique/clavier/HIstoriqueClavier";
import HistoriqueNavigation from "./pages/historique/navigation/HistoriqueNavigation";
import HistoriqueInstallation from "./pages/historique/installation/HistoriqueInstallation";
import ConfigurationAlert from "./pages/alert/configurationAlert.jsx";
import ListeAlert from "./pages/alert/listeAlert";
import PresenceList from "./pages/presence/presenceList";

function App() {
  return (
    <Router>
      <AuthProvider>
        <AlertProvider>
          <AbonnementProvider>
            <Routes>
              {/* ---- Routes publiques (sans sidebar/topbar) ---- */}
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/reset-password/:token"
                element={<ResetPassword />}
              />

              {/* ---- Routes protégées, avec Sidebar + Topbar ---- */}
              <Route
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<HomePage />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/setting" element={<Setting />} />

                <Route path="/users" element={<UsersList />} />
                <Route path="/users-desactive" element={<UsersDesactive />} />
                <Route path="/create-user" element={<CreateUser />} />
                <Route path="/edit-user/:id" element={<CreateUser />} />

                <Route path="/usage/list" element={<UsageListPage />} />
                <Route path="/historique" element={<Historique />} />
                <Route
                  path="/historique_clavier"
                  element={<HistoriqueClavier />}
                />
                <Route
                  path="/historique_navigation"
                  element={<HistoriqueNavigation />}
                />
                <Route
                  path="/historique_installation"
                  element={<HistoriqueInstallation />}
                />
                <Route path="/surveillance" element={<Surveillance />} />

                <Route path="/entreprises" element={<EntrepriseListe />} />
                <Route
                  path="/create-entreprise"
                  element={<CreateOrUpdateEntreprise />}
                />
                <Route
                  path="/edit-entreprise/:id"
                  element={<CreateOrUpdateEntreprise />}
                />

                <Route
                  path="/configuration_alert"
                  element={<ConfigurationAlert />}
                />
                <Route path="/liste_alert" element={<ListeAlert />} />

                <Route path="/offres" element={<OffreListe />} />
                <Route path="/create-offre" element={<CreateOrUpdateOffre />} />
                <Route
                  path="/edit-offre/:id"
                  element={<CreateOrUpdateOffre />}
                />

                <Route path="/presences" element={<PresenceList />} />
              </Route>
            </Routes>
          </AbonnementProvider>
        </AlertProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
